import React, { forwardRef } from 'react';

import { cn } from '../../lib/utils';

export const ModalContent = forwardRef(function ModalContent({ children, className }, ref) {
  // i took out 'scrollbar-gutter-stable' because it made places that didn't ever need scrollers to have a seemingly unnecessary right padding.
  // that looked worse than potential jumpiness from the scrollbar ever appearing.
  // maybe if we specifically need it in some place that's just something you pass in specifically.
  return (
    <div ref={ref} className={cn('flex-1 overflow-y-auto', className)}>
      {children}
    </div>
  );
});
